import LayoutBodyWrapper from "layouts/layout-parts/LayoutBodyWrapper";
import { Fragment, useState } from "react";
import { Outlet } from "react-router";
import DashboardHeader from "../layout-parts/DashboardHeader";
import DashboardSidebar from "./DashboardSidebar";
import SupportNotificationToast from "components/SupportNotificationToast";

const SIDEBAR_WIDTH = 280;
const SIDEBAR_COMPACT_WIDTH = 86;

const DashboardLayout = ({ children }) => {
  const [sidebarCompact, setSidebarCompact] = useState(false);
  const [showMobileSideBar, setShowMobileSideBar] = useState(false);

  const handleCompactToggle = () => setSidebarCompact((v) => !v);
  const handleMobileDrawerToggle = () => setShowMobileSideBar((v) => !v);

  // Responsive content offset:
  // - On < lg the sidebar is an overlay drawer => no margin, full width.
  // - On >= lg the content sits beside the fixed sidebar.
  const desktopOffset = sidebarCompact
    ? `${SIDEBAR_COMPACT_WIDTH}px`
    : `${SIDEBAR_WIDTH}px`;

  const customStyle = {
    width: {
      xs: "100%",
      lg: `calc(100% - ${desktopOffset})`,
    },
    marginLeft: {
      xs: 0,
      lg: desktopOffset,
    },
    transition: "margin-left .2s ease, width .2s ease",
  };

  return (
    <Fragment>
      <DashboardSidebar
        sidebarCompact={sidebarCompact}
        showMobileSideBar={showMobileSideBar}
        setSidebarCompact={handleCompactToggle}
        setShowMobileSideBar={handleMobileDrawerToggle}
      />

      <LayoutBodyWrapper sx={customStyle}>
        <DashboardHeader
          setShowSideBar={handleCompactToggle}
          setShowMobileSideBar={handleMobileDrawerToggle}
        />

        {children || <Outlet />}
      </LayoutBodyWrapper>
      <SupportNotificationToast />
    </Fragment>
  );
};

export default DashboardLayout;
